<template>
  <div
    ref="smallBox"
    v-drag.box="['.anchor-center']"
    class="count-small-box"
    :class="{ isSubLeft: isShowAsideTool }"
  >
    <div class="count-small" v-show="type == 0">
      <div class="count-num-box" :class="{ isEnd: count[4] }">
        <div class="count-num">
          <span class="z1">{{ count[0] }}</span>
        </div>
        <div class="count-num">
          <span class="z1">{{ count[1] }}</span>
        </div>
        <div class="count-space">:</div>
        <div class="count-num">
          <span class="z1">{{ count[2] }}</span>
        </div>
        <div class="count-num">
          <span class="z1">{{ count[3] }}</span>
        </div>
      </div>
      <div v-if="!count[4]" class="count-action">
        <template v-if="share || role === 3">
          <img
            class="count-icon"
            :src="replaySrc"
            alt="重新开始"
            @click="reCount"
            v-if="state === 4"
          />
          <img
            class="count-icon"
            :src="pauseSrc"
            alt="暂停"
            @click="resumeCount"
            v-else
          />
          <img class="count-icon" :src="refreshSrc" alt="刷新" @click="refreshCount" />
        </template>
        <el-divider direction="vertical" v-if="share || role === 3"></el-divider>
        <img
          class="count-icon"
          :src="miniSrc"
          alt="最小化"
          @click="type = 1"
        />
        <template v-if="share || role === 3">
          <el-popconfirm
            :title="$t('countDownSmall.确认结束计时吗？')"
            popper-class="tip-popconfirm"
            icon="el-icon-info"
            icon-color="#EA494B"
            @confirm="endCount"
          >
            <img
              slot="reference"
              class="count-icon"
              :src="closeSrc"
              alt="结束"
            />
          </el-popconfirm>
        </template>
      </div>
      <div v-else class="count-action" @click="close">
        <img slot="reference" class="count-icon" :src="closeSrc" alt="结束" />
      </div>
    </div>
    <div class="count-mini" v-show="type == 1" @click.stop="toBig"></div>
  </div>
</template>

<script>
import { endCD, refreshCD, suspendCD, resumeCD } from '@/api/liveRequest/countDown';
import { getParameter } from '@/utils/global';
import Role from '@/mixins/role';
import { mapGetters } from 'vuex';
export default {
  name: 'CountDownSmall',
  mixins: [Role],
  props: {
    count: Array,
    state: Number
  },
  data() {
    return {
      liveId: getParameter('liveId'),
      type: 0,
      resumeSrc: '',
      pauseSrc: '',
      refreshSrc: '',
      miniSrc: '',
      closeSrc: ''
    };
  },
  computed: {
    ...mapGetters(['isShowAsideTool'])
  },
  mounted() {
    const theme = document.querySelector('html').getAttribute("data-theme") ?? 'blue';
    if (theme.toLocaleLowerCase() == 'blue') {
      this.replaySrc = require('@/svg/icon-replay.svg');
      this.pauseSrc = require('@/svg/icon-resume.svg')
      this.refreshSrc = require('@/svg/icon-refresh.svg')
      this.miniSrc = require('@/svg/icon-mini.svg');
      this.closeSrc = require('@/svg/icon-close-cutdown.svg')
    }else{
      this.replaySrc = require('@/svg/icon-replay-light.svg');
      this.pauseSrc = require('@/svg/icon-resume-light.svg')
      this.refreshSrc = require('@/svg/icon-refresh-light.svg')
      this.miniSrc = require('@/svg/icon-mini-light.svg');
      this.closeSrc = require('@/svg/icon-close-light.svg')
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    toBig() {
      if (!this.$refs.smallBox.getAttribute('temp-move')) {
        this.type = 0;
      }
    },
    async refreshCount() {
      try {
        await refreshCD(this.liveId);
      } catch (error) {
        this.$message.error(this.$t('countDownSmall.刷新计时失败'));
      }
    },
    /**
     * 暂停计时
     */
    async resumeCount() {
      try {
        await suspendCD(this.liveId);
      } catch (error) {
        this.$message.error(this.$t('countDownSmall.暂停计时失败'));
      }
    },
    /**
     * 重新计时
     */
    async reCount() {
      try {
        await resumeCD(this.liveId);
      } catch (error) {
        this.$message.error(this.$t('countDownSmall.重新计时失败'));
      }
    },
    async endCount() {
      try {
        await endCD(this.liveId);
        //this.close();
      } catch (error) {
        this.$message.error(this.$t('countDownSmall.结束计时失败'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.count-small-box {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 999;
  transition: transform 0.3s;
}
// .isSubLeft {
//   transform: translateX(70px);
// }
.count-small {
  height: 62px;
  padding-left: 20px;
  background: rgba(#212442, 0.85);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  align-items: center;
}
[data-theme=Orange] .count-small {
  background: rgba(#fff, 0.85) !important;
}
[data-theme=Orange] .el-divider {
  background-color: #8a8f99 !important;
}

.count-num-box {
  display: flex;
  align-items: center;
  gap: 5px;
  user-select: none;

  &.isEnd {
    color: #ea494b;
  }
}
.count-num {
  position: relative;
  width: 24px;
  height: 34px;
  background: #43518c;
  border-radius: 4px;
  border: 1px solid #4d5c99;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-sizing: border-box;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
    background: #5c6499;
  }

  .z1 {
    z-index: 1;
  }
}
.count-space {
  font-size: 20px;
  margin-top: -2px;
}
.count-action {
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 10px;
}

.count-icon {
  display: block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  color: #727480;
  cursor: pointer;
  opacity: 0.4;
}
.count-icon:hover {
  opacity: 1;
}

.count-mini {
  width: 50px;
  height: 50px;
  background-color: rgba(#212442, 0.85);
  background-image: url('../../../svg/count-down.svg');
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: center;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  cursor: pointer;
}

::v-deep .el-divider {
  background-color: #121527;
  height: 62px;
}
[data-theme='Orange'] ::v-deep .el-divider {
  background-color: #F1F1F1 !important;
}
</style>
